import styles from "@/styles/components/input-search.module.scss";

import { Erase, Search } from "./Icons";

import classNames from "classnames/bind";
import { forwardRef } from "react";
const css = classNames.bind(styles);

const InputSearch = forwardRef(
  (
    {
      type,
      name,
      placeholder,
      onBlur,
      onFocus,
      onChange,
      className,
      label,
      disabled,
      value,
      autoFocus,
      erase,
    },
    ref
  ) => {
    return (
      <div
        className={css({
          inputSearchContainer: true,
          [className]: className,
        })}
        spellCheck="false"
      >
        {label && <p className={styles.label}>{label}</p>}
        <div className="relative">
          <span className={styles.icon}>
            <Search />
          </span>

          <input
            id={name}
            type={type}
            name={name}
            value={value}
            placeholder={placeholder}
            onBlur={onBlur}
            onFocus={onFocus}
            onChange={onChange}
            autoFocus={autoFocus}
            disabled={disabled}
            ref={ref}
          />

          {ref?.current?.value && (
            <div
              className={styles.erase}
              onClick={() => {
                erase();
                ref?.current?.focus();
              }}
            >
              <Erase />
            </div>
          )}
        </div>
      </div>
    );
  }
);

export default InputSearch;
